import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { SingleUserCog } from '@/icons/single-user-cog';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/users/roles')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="userManagement.rolesAndPrivileges.crumb.rolesPrivileges" icon={SingleUserCog} />,
      title: <Translation id="userManagement.rolesAndPrivileges.crumb.rolesPrivileges" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
